module.exports = __webpack_public_path__ + "static/media/tability_logo_full.0a2a6ba0.png";